const config = {
    // host: "http://localhost:2000"
    host: process.env.REACT_APP_API_URL
}

export default config;
